import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import AboutUs from "../pages/about-us/page";
import ContactUs from "../pages/contact-us/page";
import Events from "../pages/events/page";
import FrankfurtBookFair2026 from "../pages/events/frankfurt-book-fair-2026/page";
import VerifiedParticipation from "../pages/events/verified-participation/page";
import Ratings from "../pages/ratings/page";
import TermsAndConditions from "../pages/terms-and-conditions/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import Layout from "../components/feature/Layout";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/services",
        element: <Services />,
      },
      {
        path: "/about-us",
        element: <AboutUs />,
      },
      {
        path: "/contact-us",
        element: <ContactUs />,
      },
      {
        path: "/events",
        element: <Events />,
      },
      {
        path: "/events/frankfurt-book-fair-2026",
        element: <FrankfurtBookFair2026 />,
      },
      {
        path: "/events/verified-participation",
        element: <VerifiedParticipation />,
      },
      {
        path: "/ratings",
        element: <Ratings />,
      },
      {
        path: "/terms-and-conditions",
        element: <TermsAndConditions />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;